export const WORKSPACE_NAME_ID = "workspace-name";
export const WORKSPACE_DESCRIPTION_ID = "workspace-description";
export const WORKSPACE_SPECIALTY_ID = "workspace-specialty";

export const WORKSPACE_NAME_CHAR_LIMIT = 100;
export const WORKSPACE_DESCRIPTION_CHAR_LIMIT = 100;
export const WORKSPACE_NAME_MIN_CHAR = 3;
export const WORKSPACE_DESCRIPTION_MIN_CHAR = 3;
